angular.module('leanlaw').factory('wipBilledCollectedDefinition', ['singleRequest', function (singleRequest) {
  const headersFromType = type => {
    if (type === 'client') {
      return [{
        id: 'reference',
        label: 'ID'
      }, {
        id: 'name',
        label: `Client/Matter`,
        matterPrefix: true
      }];
    }
    if (type === 'user') {
      return [{
        id: 'name',
        label: 'Name'
      }];
    }
    if (type === 'matterTag') {
      return [{
        id: 'label',
        label: 'Practice Area',
        sort: sortOptionalString
      }];
    }
    throw Error("Missing or unknown report type");
  };
  const sortOptionalString = (a, b) => {
    // if we don't have an id, it's "No Practice Area" (or in general: no category whatever the category is) 
    // which should go at the end
    if (!a.id) return -1;
    if (!b.id) return 1;
  };
  const dataColumns = [{
    id: 'wipServices',
    label: 'WIP Services',
    filter: 'amount',
    number: true
  }, {
    id: 'wipExpenses',
    label: 'WIP Expenses',
    filter: 'amount',
    number: true
  }, {
    id: 'interimServices',
    label: 'Draft Services',
    filter: 'amount',
    number: true
  }, {
    id: 'interimExpenses',
    label: 'Draft Expenses',
    filter: 'amount',
    number: true
  }, {
    id: 'billedServices',
    label: 'Billed Services',
    filter: 'amount',
    number: true,
    toolTip: 'Billed Services is net of credits (except where credits are shown in a separate column)'
  }, {
    id: 'billedExpenses',
    label: 'Billed Expenses',
    filter: 'amount',
    number: true
  }, {
    id: 'collectedServices',
    label: 'Collected Services',
    filter: 'amount',
    number: true
  }, {
    id: 'collectedExpenses',
    label: 'Collected Expenses',
    filter: 'amount',
    number: true
  }];
  const cancel = params => {
    singleRequest.cancel(params.type);
  };
  const load = config => ({
    query,
    params
  }) => {
    const {
      type,
      showUnassigned
    } = params;
    query.primary = `${type.toLowerCase()}s`;
    query.zeros = false;
    query.billed = false;
    query.billedState = undefined;
    query.data = 'services,expenses,charges,invoices,payments';
    if (config) {
      Object.assign(query, config(params).query);
    }
    const headers = headersFromType(type);
    return singleRequest.apiCall(`wip-${type}`, true).getReport(query).then(result => {
      if (!result) return undefined;
      const rows = result[`${type}s`].map(c => {
        const row = rowFromData(c[type.toLowerCase()], c.data, headers);
        if (type === 'client') {
          row.rows = c.matters.map(m => rowFromData(m.matter, m.data, headers));
        }
        return row;
      });
      if (result.unallocated && showUnassigned) {
        const item = {
          id: 'none',
          name: 'Unassigned'
        };
        rows.push(rowFromData(item, result.unallocated, headers));
      }
      return {
        rows
      };
    });
  };
  function rowFromData(item, data, headers) {
    const values = headers.reduce((vs, h) => {
      // italizie if we don't have an id (no practice)
      vs[h.id] = {
        value: item[h.id],
        italic: !item.id
      };
      return vs;
    }, {});
    if (data.amounts) {
      values.wipServices = {
        value: data.amounts.hours + data.amounts.charges
      };
      values.wipExpenses = {
        value: data.amounts.expenses
      };
    }
    if (data.invoiced) {
      values.billedServices = {
        value: data.finalBilled.servicesTotal - data.finalBilled.credits
      };
      values.billedExpenses = {
        value: data.finalBilled.expensesTotal
      };
      values.interimServices = {
        value: data.interimBilled.servicesTotal - data.interimBilled.credits
      };
      values.interimExpenses = {
        value: data.interimBilled.expensesTotal
      };
    }
    if (data.collected) {
      values.collectedServices = {
        value: data.collected.servicesTotal
      };
      values.collectedExpenses = {
        value: data.collected.expensesTotal
      };
    }
    return {
      id: item.id,
      label: item.label || item.name,
      values
    };
  }
  const structure = config => ({
    params,
    me
  }) => {
    const headers = headersFromType(params.type);
    const totalLabelCells = headers.length;
    const showFilters = config && config(params).show;
    return {
      sort: headers[0].id,
      subrow: {
        label: params.type === 'client' ? `${me.terms.Matter}s` : undefined
      },
      totals: {
        rows: true,
        columns: false,
        totalLabelCells
      },
      showFilters: {
        dateRange: true,
        matterForUser: true,
        distribution: false,
        ...showFilters
      },
      columns: headers.concat(dataColumns)
    };
  };
  return config => ({
    structure: structure(config),
    load: load(config),
    cancel
  });
}]);